/**
 * Rutas de Configuración — acceso vía routeAccessMatrix.js
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import PermissionRoute from '../components/PermissionRoute.jsx'
import ConfigEmpresa from '../pages/configuracion/company/ConfigEmpresa.jsx'
import ConfigPlantas from '../pages/configuracion/plants/ConfigPlantas.jsx'
import ConfigCalendario from '../pages/configuracion/calendar/ConfigCalendario.jsx'
import ConfigTurnos from '../pages/configuracion/shifts/ConfigTurnos.jsx'
import ConfigZonasHorarias from '../pages/configuracion/timezones/ConfigZonasHorarias.jsx'
import ConfigUnidades from '../pages/configuracion/units/ConfigUnidades.jsx'
import ConfigMonedas from '../pages/configuracion/currencies/ConfigMonedas.jsx'
import Empleados from '../pages/personas/empleados/Empleados.jsx'
import GrafanaTest from '../components/GrafanaTest.jsx'
import ConfigExternal from '../pages/configuracion/external/ConfigExternal.jsx'

const withAcl = (Page) => (
  <ProtectedRoute>
    <PermissionRoute>
      <Page />
    </PermissionRoute>
  </ProtectedRoute>
)

export const configRoutes = [
  <Route key="config-empresa" path="/config-empresa" element={withAcl(ConfigEmpresa)} />,
  <Route key="config-plantas" path="/config-plantas" element={withAcl(ConfigPlantas)} />,
  <Route key="config-calendario" path="/config-calendario" element={withAcl(ConfigCalendario)} />,
  <Route key="config-turnos" path="/config-turnos" element={withAcl(ConfigTurnos)} />,
  <Route key="config-zonas-horarias" path="/config-zonas-horarias" element={withAcl(ConfigZonasHorarias)} />,
  <Route key="config-unidades" path="/config-unidades" element={withAcl(ConfigUnidades)} />,
  <Route key="config-monedas" path="/config-monedas" element={withAcl(ConfigMonedas)} />,
  <Route key="gestion-empleados" path="/gestion-empleados" element={withAcl(Empleados)} />,
  <Route key="grafana-test" path="/grafana-test" element={withAcl(GrafanaTest)} />,
  <Route key="config-external" path="/config-external" element={withAcl(ConfigExternal)} />,
]
